var map = {
	"./Investigation.svg": "8183",
	"./Management.svg": "1ce7",
	"./Project.svg": "7ead",
	"./Registration.svg": "410d",
	"./appointment.svg": "cf3a",
	"./appointmentActive.svg": "dd48",
	"./appraisal.svg": "2d77",
	"./assign.svg": "0169",
	"./bmgz.svg": "0ee5",
	"./capacity.svg": "1b21",
	"./code.svg": "ea0b",
	"./complaint.svg": "a444",
	"./dispose.svg": "f687",
	"./djdj.svg": "e7a8",
	"./document.svg": "6bca",
	"./download.svg": "d5dc",
	"./employment.svg": "f6ce",
	"./en-complaint.svg": "6f15",
	"./enterprise.svg": "b5aa",
	"./exception.svg": "b78b",
	"./file.svg": "fc0c",
	"./gayw.svg": "0a90",
	"./gjbs.svg": "a897",
	"./index.svg": "d0a1",
	"./insert.svg": "a49c",
	"./jcdt.svg": "32be",
	"./jgdt.svg": "87ba",
	"./jwgk.svg": "4abd",
	"./jyfc.svg": "669e",
	"./labor.svg": "ebc7",
	"./level.svg": "31d8",
	"./line-chart-header.svg": "bf53",
	"./monitor.svg": "61cd",
	"./online.svg": "d9e1",
	"./organ.svg": "3cf5",
	"./organization.svg": "20da",
	"./policy-service.svg": "1980",
	"./policy.svg": "8334",
	"./rankA.svg": "45738",
	"./rankB.svg": "994d",
	"./rankC.svg": "c73f",
	"./reconside.svg": "2506",
	"./returned.svg": "3833",
	"./review.svg": "b3aa",
	"./signIn.svg": "fdb1",
	"./site.svg": "7332",
	"./statistics.svg": "ce7f",
	"./szyw.svg": "cac2",
	"./task.svg": "f5ab",
	"./training.svg": "c65d",
	"./trainingClassData.svg": "965c",
	"./trainingInstitutionData.svg": "71f0",
	"./tretdetetaff.svg": "4b6b",
	"./tztb.svg": "5461",
	"./uploadfile.svg": "410f",
	"./work.svg": "0940",
	"./xtsz.svg": "fd64",
	"./xtts.svg": "46e4",
	"./yygl.svg": "4d5d",
	"./zbdb.svg": "3646",
	"./zcgl.svg": "f13b",
	"./ztzl.svg": "e8dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "abe8";